import { h } from 'preact'

/* eslint-disable import/no-internal-modules */
import globals from '@insided/deprecated-utils/globals'
import ButtonControl from '@insided/deprecated-preact-components/button-control'
import Tooltip from '@insided/deprecated-control/ui-components/Tooltip'
import Icon from '@insided/deprecated-preact-components/assets'
import AlertComponent from '@insided/deprecated-control/ui-components/AlertComponent'

interface EscalateButtonProps {
  tooltipMessage: string
  imageName: string
  isDisabled: boolean
  onClick: () => void
  customClasses: string
}

export const EscalateButton = ({ tooltipMessage, imageName, isDisabled, onClick, customClasses }: EscalateButtonProps) => {
  return (
    <Tooltip
      position='button-bottom'
      trigger={<ButtonControl
        title={<img height={16} width={16} src={`${globals('basePath')}images/integrations/${imageName}.png`} />}
        variant='secondary'
        onClick={() => onClick()}
          // eslint-disable-next-line @gorazdo/preact/prefer-classname
        class={`integration__button_escalate ${customClasses}`}
        disabled={isDisabled}
               />}
      customClasses='integration__tooltip'
      tooltipMessage={tooltipMessage}
    />
  )
}

interface EscalatedButtonProps {
  redirectUrl: string | null
  imageName: string
  title: string
  customClasses: string
}

export const EscalatedButton = ({ redirectUrl, imageName, title, customClasses }: EscalatedButtonProps) => {
  if (redirectUrl === null) {
    return null
  }
  return (
    <ButtonControl
      newStyle
        // eslint-disable-next-line @gorazdo/preact/prefer-classname
      class='button__escalated'
      onClick={() => window.open(redirectUrl)}
      size='medium'
      title={<div className='button__escalated_title-wrapper'>
        <div className='button__escalation_company_logo_wrapper'>
          <img height={20} width={20} src={`${globals('basePath')}images/integrations/${imageName}.png`} />
        </div>
        <span className={`button__escalated_title ${customClasses}`} data-prop={redirectUrl}>{title}</span>
        <Icon customClass='icon-external-link' icon='externalLink' width={16} height={16} />
      </div>}
    />
  )
}

export const AlertMessage = ({ messageType, message }: {messageType?: string|null, message?: string}) => {
  const isVisibleFor = messageType === 'success' ? 5000 : false

  return (
    messageType ? <AlertComponent messageType={messageType} message={message} sticky renderHTML isVisibleFor={isVisibleFor} /> : null
  )
}
